export const weightRange = {
  '0-2': '0 - 2 lbs',
  '2-5': '2 - 5 lbs',
  '5-50': '5 - 50 lbs',
  '100-250': '100 - 250 lbs',
  '250-500': '250 - 500 lbs',
  '500-1000': '500 - 1,000 lbs',
  '1000': 'Over 1,000 lbs',
};
export const Aluminum = {
  'Aluminum Copper (200 Series)': 'Aluminum Copper (200 Series)',
  'Aluminum Silicon (300 Series)': 'Aluminum Silicon (300 Series)',
  'Aluminum Silicon (400 Series)': 'Aluminum Silicon (400 Series)',
  'Aluminum Magnesium (500 Series)': 'Aluminum Magnesium (500 Series)',
  'Aluminum Alloys (600 Series)': 'Aluminum Alloys (600 Series)',
  'Aluminum Alloys (700 Series)': 'Aluminum Alloys (700 Series)',
  'Aluminum Alloys (800 Series)': 'Aluminum Alloys (800 Series)',
  /**
    '201': '201',
    '202': '202',
    '204': '204',
    '206': '206',
    '208': '208',
    '308': '308',
    '318': '318',
    '319': '319',
    '332': '332',
    '354': '354',
    '355': '355',
    '356': '356',
    '357': '357',
    '359': '359',
    '360': '360',
    '380': '380',
    '390': '390',
    '413': '413',
    '443': '443',
    '514': '514',
    '535': '535',
    '707': '707',
    '712': '712',
    '713': '713',
    '771': '771',
    '850': '850',
    A201: 'A201',
    A206: 'A206',
    A356: 'A356',
    A357: 'A357',
    A380: 'A380',
    A383: 'A383',
    B443: 'B443',
    C355: 'C355',
    E357: 'E-357',
  */
};
export const copper = {
  "Aluminum Bronze": "Aluminum Bronze",
  "Beryllium Copper": "Beryllium Copper",
  "Copper Nickel": "Copper Nickel",
  "High Copper Alloys": "High Copper Alloys",
  "Leaded Tin Bronze": "Leaded Tin Bronze",
  "Low Lead/Lead-Free Brass": "Low Lead/Lead-Free Brass",
  "Manganese Bronze": "Manganese Bronze",
  "Nickel Silver": "Nickel Silver",
  "Pure Copper": "Pure Copper",
  "Red Brass": "Red Brass",
  "Silicon Bronze": "Silicon Bronze",
  "Tin Bronze": "Tin Bronze",
  "Yellow Brass": "Yellow Brass"
  /** 
  C80100: 'C80100',
  C81500: 'C81500',
  C82400: 'C82400',
  C82500: 'C82500',
  C83300: 'C83300',
  C83400: 'C83400',
  C83450: 'C83450',
  C83600: 'C83600',
  C83800: 'C83800',
  C84200: 'C84200',
  C84400: 'C84400',
  C84500: 'C84500',
  C84800: 'C84800',
  C85200: 'C85200',
  C85400: 'C85400',
  C85500: 'C85500',
  C85700: 'C85700',
  C85800: 'C85800',
  C86100: 'C86100',
  C86200: 'C86200',
  C86300: 'C86300',
  C86400: 'C86400',
  C86500: 'C86500',
  C86700: 'C86700',
  C86800: 'C86800',
  C87200: 'C87200',
  C87300: 'C87300',
  C87400: 'C87400',
  C87500: 'C87500',
  C87600: 'C87600',
  C87610: 'C87610',
  C87800: 'C87800',
  C89320: 'C89320',
  C89325: 'C89325',
  C89510: 'C89510',
  C89520: 'C89520',
  C89831: 'C89831',
  C89833: 'C89833',
  C89835: 'C89835',
  C89837: 'C89837',
  C90200: 'C90200',
  C90300: 'C90300',
  C90500: 'C90500',
  C90700: 'C90700',
  C90900: 'C90900',
  C91000: 'C91000',
  C91100: 'C91100',
  C91300: 'C91300',
  C91600: 'C91600',
  C91700: 'C91700',
  C92200: 'C92200',
  C92300: 'C92300',
  C92410: 'C92410',
  C92500: 'C92500',
  C92600: 'C92600',
  C92700: 'C92700',
  C92800: 'C92800',
  C92900: 'C92900',
  C93200: 'C93200',
  C93400: 'C93400',
  C93500: 'C93500',
  C93600: 'C93600',
  C93700: 'C93700',
  C93800: 'C93800',
  C93900: 'C93900',
  C94100: 'C94100',
  C94300: 'C94300',
  C94400: 'C94400',
  C94500: 'C94500',
  C94700: 'C94700',
  C94800: 'C94800',
  C95200: 'C95200',
  C95300: 'C95300',
  C95400: 'C95400',
  C95410: 'C95410',
  C95500: 'C95500',
  C95600: 'C95600',
  C95700: 'C95700',
  C95800: 'C95800',
  C96200: 'C96200',
  C96300: 'C96300',
  C96400: 'C96400',
  C96600: 'C96600',
  C97300: 'C97300',
  C97400: 'C97400',
  C97600: 'C97600',
  C99500: 'C99500',
  C99700: 'C99700',
*/
};

export const Iron = {
  "Abrasion Resistant Iron": "Abrasion Resistant Iron",
  "Austempered Ductile Iron": "Austempered Ductile Iron",
  "Compacted Graphite Iron": "Compacted Graphite Iron",
  "Corrosion Resistant Iron": "Corrosion Resistant Iron",
  "Ductile Iron": "Ductile Iron",
  "Grey Iron": "Grey Iron",
  "Heat Resistant Iron": "Heat Resistant Iron",
  "Malleable Iron": "Malleable Iron",
  "White Iron": "White Iron"
};

export const MMC = {
  'Silicon Carbide Alloys': 'Silicon Carbide Alloys',
};

export const other = {
  "Cobalt Base": "Cobalt Base",
  "Lead": "Lead",
  "Magnesium": "Magnesium",
  "Metal Matrix Composites": "Metal Matrix Composites",
  "Nickel-Base": "Nickel-Base",
  "Other": "Other",
  "Precious Metals": "Precious Metals",
  "Superalloys": "Superalloys",
  "Titanium": "Titanium",
  "Zinc-Base": "Zinc-Base"
  /** 
  'Berrylium Copper': 'Berrylium Copper',
  'Cobalt Based': 'Cobalt Based',
  Lead: 'Lead',
  Magnesium: 'Magnesium',
  'Nickel-Based': ' Nickel-Based',
  Superalloys: 'Superalloys',
  Titanium: 'Titanium',
  Zinc: 'Zinc',
  */
};

export const steel = {
  "Carbon Steel": "Carbon Steel",
  "Corrosion Resistant Steel": "Corrosion Resistant Steel",
  "Heat Resistant Steel": "Heat Resistant Steel",
  "Low Alloy Steel": "Low Alloy Steel",
  "Manganese Steel": "Manganese Steel"
  /** 
  'Carbon Low Alloy': 'Carbon Low Alloy',
  'Corrosion Resistant': 'Corrosion Resistant',
  'HY-100': 'HY-100',
  'HY-130': 'HY-130',
  'HY-80': 'HY-80',
  'Specialty Steels': 'Specialty Steels',
  */
};

export const alloySteel = {
  "4130": "4130",
  "4140": "4140",
  "4340": "4340",
  "8620": "8620",
  "9310": "9310",
  "H13": "H13",
  "A2": "A2",
  "D2": "D2",
  "M2": "M2",
  "S7": "S7"
};



// WEBPACK FOOTER //
// ./src/config/SupplierSearchOptions/MaterialOptions.js